const getNextSourceIndex = (sources, currentIndex = -1) => {
   let index = currentIndex;
   do {
      index += 1;
   } while (index <= sources.length && !sources[index]?.buffer);
   return index;
};

const createSourcesMap = (sources, [noteRangeLow, noteRangeHigh]) => {
   const sourcesMap = {};
   let sourceIndex = getNextSourceIndex(sources);
   let nextSourceIndex = getNextSourceIndex(sources, sourceIndex);
   for (let i = noteRangeLow; i <= noteRangeHigh; i += 1) {
      const currentSource = sources[sourceIndex];
      const nextSource = sources[nextSourceIndex];
      if (currentSource == null) {
         sourcesMap[i] = 0;
      } else if (
         nextSource != null &&
         i > (currentSource.noteValue + nextSource.noteValue) / 2
      ) {
         sourcesMap[i] = nextSourceIndex;
         sourceIndex = getNextSourceIndex(sources, sourceIndex);
         nextSourceIndex = getNextSourceIndex(sources, sourceIndex);
      } else {
         sourcesMap[i] = sourceIndex;
      }
   }
   return sourcesMap;
};

export { createSourcesMap };
